import React from "react";
import { AccessibilityClickableDiv } from "@skillz/accessibility";
import BottomSheetActionButton from "./bottomSheetActionButton/BottomSheetActionButton";
import classes from "./BottomSheet.module.css";

const BottomSheet = ({ isOpen, close, children, actionText, onAction, dropClassOverlay, dropClassSheet, dropClassActionButton }) => {
    
    const closeSheet = () => close && close();
    const handleAction = () => {
        onAction && onAction();
        closeSheet();
    };
    
    return (
        <>
            {isOpen ?
                <div className={`${classes.Overlay} ${dropClassOverlay || ""}`}>
                    <AccessibilityClickableDiv className={classes.OverlayCloseArea} onClick={closeSheet} role="button" />
                    <div className={`${classes.Sheet} ${dropClassSheet || ""}`}>
                        <div className={classes.Content}>
                            {children}
                        </div>
                        {actionText ?
                            <BottomSheetActionButton onClick={handleAction} dropClass={`${classes.ActionButton} ${dropClassActionButton || ""}`}>
                                {actionText}
                            </BottomSheetActionButton>
                            : null}
                    </div>
                </div>
                : null}
        </>
    );
};

export default BottomSheet;
